import { gql } from '@apollo/client';

export const GET_MY_TOOLS = gql`
  query MyTools($limit: Int, $offset: Int, $date: ISO8601Date!) {
    myTools(limit: $limit, offset: $offset) {
      items {
        id
        name
        description
        primaryImageUrl
        pricePerDayCents
        city
        postalCode
        nextAvailableDate(date: $date)
        availabilityStatus
        categories {
          id
          name
          code
        }
      }
      totalCount
    }
  }
`;
